import script from "./FeedbackEntranceSimple.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackEntranceSimple.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackEntranceSimple.vue?vue&type=style&index=0&id=0aeb6c87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeb6c87"]])

export default __exports__